module.exports = __webpack_public_path__ + "img/FLDCOMP.e065874e.svg";